function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSvgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface19461708"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(64.313728%,64.313728%,64.313728%)",
      fillOpacity: 1
    },
    d: "M 25 2 C 12.296875 2 2 12.296875 2 25 C 2 37.703125 12.296875 48 25 48 C 37.703125 48 48 37.703125 48 25 C 48 12.296875 37.703125 2 25 2 Z M 25 11 C 26.65625 11 28 12.34375 28 14 C 28 15.65625 26.65625 17 25 17 C 23.34375 17 22 15.65625 22 14 C 22 12.34375 23.34375 11 25 11 Z M 29 38 L 21 38 L 21 36 L 23 36 L 23 23 L 21 23 L 21 21 L 27 21 L 27 36 L 29 36 Z M 29 38 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSvgIcon);
export default __webpack_public_path__ + "static/media/infoSVGIcon.3d38b6a6.svg";
export { ForwardRef as ReactComponent };